import React, { useState } from 'react'
import VariableType from '../VariableType';
import VariableCategory from '../VariableCategory';
import VariableSubCategory from '../VariableSubCategory';
import Language from '../Language/Language';

function Utility({ editable }) {
    const [activeComponent, setActiveComponent] = useState("Variable Type");

    const tabs = [
        { name: "Variable Type", component: <VariableType editable={editable} /> },
        { name: "Variable Category", component: <VariableCategory editable={editable} /> },
        { name: "Variable Sub-Category", component: <VariableSubCategory editable={editable} /> },
        { name: "Language", component:<Language editable={editable}/>},
    ];

    const renderComponent = () => {
        const activeTab = tabs.find(tab => tab.name === activeComponent);
        return activeTab ? activeTab.component : null;
    };

    const changeActiveComponent = (name) => {
        setActiveComponent(name)
    }

    return (
        <div className="w-full flex flex-col items-center mt-4">
            <div className="flex gap-2 max-w-100 flex-wrap mb-2">
                {tabs.map(({ name }) => (
                    <button
                        key={name}
                        className={`p-2 rounded-lg text-sm border-b-2 min-w-[100px] ${
                            activeComponent === name
                                ? "activeBtn text-white"
                                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                        }`}
                        onClick={() => { changeActiveComponent(name) }}
                    >
                        {name}
                    </button>
                ))}
            </div>
            {renderComponent()}
        </div>
    )
}

export default Utility;
